<span class="pr-2">
  {{ client.first_name }} {{ client.last_name }}
  <ng-content></ng-content>
</span>
<a
  *ngIf="showLink"
  target="_blank"
  [routerLink]="['/', 'clients', 'details', client.uuid]"
  class="pr-2"
  ><mat-icon>open_in_new</mat-icon></a
>
